import { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { root } from './router';

export const router = createBrowserRouter(root);

export const RootRouter: FC = () => {
  return <RouterProvider router={router} />;
};
